var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBusinessWoman(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 244.281,
    height: 599.117,
    viewBox: "0 0 244.281 599.117",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#593432;}.b{fill:#a36d4f;}.c{fill:#fff;}.d,.f{fill:#454545;}.e{fill:#9cd6f0;}.f,.q{mix-blend-mode:screen;}.f,.h,.j,.q{isolation:isolate;}.g{fill:#5979d7;}.h{fill:#dbdbdb;}.h,.j{mix-blend-mode:multiply;}.i{fill:#8f5f45;}.j{fill:#d6d6d6;}.k{fill:#693e3b;}.l{fill:#5c3124;}.m{fill:#f2f2f2;}.n{fill:#4b838f;}.o{fill:#589aa8;}.p{fill:#b5b5b5;}.q{fill:#828282;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-114.643 -329.878)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M277.751,443.087a6.8,6.8,0,0,0,1.034-.351c4.174-2.506,5.851-8.425,3.754-13.223a9.257,9.257,0,0,0-2.331-3.189,10.735,10.735,0,0,0,2.926-12.453,8.612,8.612,0,0,0-3.794-4.115,10.811,10.811,0,0,0,2.253-11.839,8.46,8.46,0,0,0-5.207-4.847,11.031,11.031,0,0,0,.79-10.083,8.1,8.1,0,0,0-6.963-5.071,11.021,11.021,0,0,0-.059-8.338,8.108,8.108,0,0,0-7.753-5.168,11.075,11.075,0,0,0-.5-7.168c-1.941-4.437-6.426-6.182-10.386-4.447,0-.322-.088-.614-.107-.936a10.828,10.828,0,0,0-.741-5.081c-2.087-4.788-7.158-6.631-11.322-4.125a8.148,8.148,0,0,0-.9.839c-.653-4.349-3.647-7.781-7.626-8a7.769,7.769,0,0,0-5.88,2.379c-1.17-3.384-3.891-5.861-7.255-6.046a7.955,7.955,0,0,0-6.631,3.326c-1.307-2.945-3.774-5.1-6.855-5.266-3.247-.176-6.1,1.882-7.675,4.934a7.853,7.853,0,0,0-5.968-3.511c-4-.224-7.363,2.906-8.465,7.187a7.625,7.625,0,0,0-4.808-2.321c-4.291-.234-7.909,3.364-8.7,8.152a7.357,7.357,0,0,0-3.471-1.16c-4.652-.253-8.669,3.92-8.962,9.323a8.592,8.592,0,0,0,.146,1.238,7.359,7.359,0,0,0-1.59-.907c-4.5-1.355-9.147,1.785-10.4,7.021a10.9,10.9,0,0,0,.419,6.124c-4.252-.809-8.474,2.126-9.654,7.08a11.064,11.064,0,0,0,.712,7.138,9.224,9.224,0,0,0-6.719,7.109,10.792,10.792,0,0,0,1.346,8.162,9.259,9.259,0,0,0-5.968,6.8,10.607,10.607,0,0,0,2.535,9.762,9.824,9.824,0,0,0-4.164,6.066,10.13,10.13,0,0,0,4.193,10.98,9.906,9.906,0,0,0-3.023,5.022c-1.141,4.827,1.092,9.606,4.954,11.41a10.268,10.268,0,0,0-1.746,3.725c-1.248,5.237,1.395,10.59,5.89,11.946a7.429,7.429,0,0,0,1.97.127c-.049.146-.146.253-.185.409-1.248,5.237,1.395,10.59,5.89,11.946a6.955,6.955,0,0,0,2.145.136c-1.219,5.227,1.4,10.552,5.89,11.907a7.243,7.243,0,0,0,3.559.117c-.361,4.632,2,9.01,6,10.22a7.129,7.129,0,0,0,4.661-.332c.38,3.852,2.691,7.207,6.114,8.24a7.48,7.48,0,0,0,6.329-1c.79,3.13,2.789,5.754,5.7,6.641a7.561,7.561,0,0,0,7.46-2.1c.136.234.175.507.322.732a7.655,7.655,0,0,0,11.868,1.336c.107-.108.156-.253.263-.361a9.586,9.586,0,0,0,.9,2.018,7.642,7.642,0,0,0,11.868,1.336,9.665,9.665,0,0,0,2.243-3.354,7.507,7.507,0,0,0,11.068.575,10.2,10.2,0,0,0,2.75-5.227,7.444,7.444,0,0,0,10.415-.058,10.4,10.4,0,0,0,3.111-6.846,7.482,7.482,0,0,0,8.776-1.3,10.666,10.666,0,0,0,2.965-9.04,7.508,7.508,0,0,0,7.021-1.911,10.82,10.82,0,0,0,2.906-9.957,7.724,7.724,0,0,0,5.958-2.165,10.871,10.871,0,0,0,1.677-13.028,7.692,7.692,0,0,0,5.032-2.058,10.938,10.938,0,0,0,1.346-13.789A8.112,8.112,0,0,0,277.751,443.087Z",
    transform: "translate(69.012 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M118.654,354.149h0a7.542,7.542,0,0,1,7.928-5.5c30.942,2.692,50.612,4.885,65.346,6.963,16.373,2.3,19.845,26.973,6,24.955-16.1-2.35-44.741-7.626-73.645-14.237C117.864,364.866,117.425,358.566,118.654,354.149Z",
    transform: "translate(30.324 164.017)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M149.755,377.525c-5.754-1.248-13.126-.858-23.16-2.7-4.632-.849-1.941-25.8,1.824-25.745,24.545,1.853,27.51,1.365,30.445,10.707C160.755,365.755,159.224,379.592,149.755,377.525Z",
    transform: "translate(83.146 168.043)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(114.643 371.04)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "d",
    width: 87.204,
    height: 57.834,
    rx: 0.367,
    transform: "translate(62.477 3.136) rotate(93.108)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.98,335.275l-2.012,37.052-59.247,24.452,2.012-37.052Z",
    transform: "translate(-113.956 -323.805)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.418,368.9a3.58,3.58,0,0,1-3.774,3.384l-50.592-2.75a3.581,3.581,0,0,1-3.384-3.774l.068-1.287,59.252-24.448Z",
    transform: "translate(-114.474 -282.262)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M167.846,407.522l3.754-69.15a.565.565,0,0,0-.536-.585l-51.782-2.809a.559.559,0,0,0-.595.527l-3.745,69.14a.559.559,0,0,0,.527.595l51.782,2.809A.559.559,0,0,0,167.846,407.522Z",
    transform: "translate(-112.029 -326.407)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M175.98,335.275l-2.012,37.052-59.247,24.452,2.012-37.052Z",
    transform: "translate(-113.956 -323.805)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M172.418,368.9a3.58,3.58,0,0,1-3.774,3.384l-50.592-2.75a3.581,3.581,0,0,1-3.384-3.774l.068-1.287,59.252-24.448Z",
    transform: "translate(-114.474 -282.262)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.871,336.423a.947.947,0,1,0-.9-.995A.946.946,0,0,0,118.871,336.423Z",
    transform: "translate(-85.511 -330.328)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.786,335.236a.337.337,0,0,0,.029-.673.33.33,0,0,0-.351.312A.34.34,0,0,0,117.786,335.236Z",
    transform: "translate(-89.956 -330.047)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M124.555,373.573c-.731-5.549-1.122-9.527-3.179-12.589-3.013-4.466-4.144-6.339-4.554-10.454-.419-4.183,2.594-6.27,5.568-7.635,4.886-2.233,11.868-1.18,13.175,2.955,1.57,4.983.127,8.854-.6,12.833-1.209,6.592-.624,9.011.214,12.765S124.887,376.137,124.555,373.573Z",
    transform: "translate(18.727 103.879)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(141.082 463.473)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M117.371,346.176c3.55,20.332,5.178,45.141,7.489,57.418a9.2,9.2,0,0,0,10.522,7.246h0a8.932,8.932,0,0,0,7.236-10.825c-2.9-12.336-9.566-34.609-13.379-55.5a1.126,1.126,0,0,0-1.277-.926l-9.635,1.268A1.136,1.136,0,0,0,117.371,346.176Z",
    transform: "translate(-117.354 -343.578)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M169.569,434.464h0c3.277-1.56,4.827-5.822,3.891-9.333-8.006-30.016-12.716-48.222-17.309-62.372-5.09-15.729-29.275-16.812-24.9-3.52,5.09,15.447,13.682,43.093,25.335,71.792C159.066,437.127,165.424,436.435,169.569,434.464Z",
    transform: "translate(140.761 176.527)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M131.34,360.456c2.233,5.451,4.564,13.7,8.1,23.267,1.638,4.418,24.038-2.4,23.336-6.1-7.206-24.828-10.112-26.485-19.825-27.763C136.753,349.027,127.664,351.495,131.34,360.456Z",
    transform: "translate(138.705 173.526)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M123.615,441.086c5.3-64.264,11.829-80.178,32.737-79.33,16.12.663,23.17,44.663-3.91,155.013-4.973,14.092-10.62,14.618-17.319,12.268C127.077,526.219,123.7,474.925,123.615,441.086Z",
    transform: "translate(78.519 278.706)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M132.607,405.561c-11.429-14.354-9.547-22.165-3.9-27.217,4.769-4.272,17.417,3.452,26.466,11.468,19.855,17.6,30.952,36.169,48.573,68.057v.01c6.846,10.854,13.614,21.746,15.808,26.057,2.867,5.607-2.935,11.361-8.035,5.977S194.96,472.721,191.01,468.7l-.107-.127c-.049-.019-.146.01-.185-.019C190.718,468.557,157.045,436.259,132.607,405.561Z",
    transform: "translate(83.911 413.504)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M173.635,437.1c4.954-48.817-8.747-75.761-21.883-75.634-16.139.166-34.1,55.751-14.3,148.09,3.559,14.511,9.137,15.593,16.022,13.926C161.767,521.468,170.193,470.759,173.635,437.1Z",
    transform: "translate(123.413 276.406)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M132.4,399.575c2.731-11.78,9.557-24.175,15.925-23.453,7.528.839,12.512,10.4,11.595,23.209-2.818,39.144-10.8,81.368-10.8,81.368-.02.049-.117.078-.137.127l-.02.166c-.887,5.559-3.384,21.834-4.427,29.167s-9.1,6.007-10.015-.214c-.712-4.788-1.492-17.582-2.2-30.406h0C128.2,443.341,126.411,425.417,132.4,399.575Z",
    transform: "translate(121.625 404.453)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M133.036,417.65c-18.5-18.977-2.633-43,7.567-57.789,13.643,6.485,41.2,3.647,49.7,1.97,7.5,13.779,23.063,36.52,8.942,52.757C182.019,434.393,154.773,439.932,133.036,417.65Z",
    transform: "translate(86.349 262.404)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(218.432 513.649)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M193.955,359.832c2.4,2.477,6.612,28.768,6.748,44.312.156,17.924-14.8,23.19-18.08,50.407-.263,2.233,1.863,4.71,2.9,6.709,6.592,12.824-60.432,9.216-52.552-3.354,1.112-1.775,3.842-4.866,3.91-6.953.692-22.146-13.243-37.768-11.429-51.587,1.385-10.551,11.848-39.719,13.155-42.684.458-1.843,18.119-8.465,26.135-7.928C175.749,349.485,191.449,357.969,193.955,359.832Z",
    transform: "translate(-125.286 -348.723)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M150.081,360.164c2.8-.039-10.59-8.211-22.117-1.97-1.365,1.258,4.886.409,10.551.712C144.425,359.228,148.892,360.1,150.081,360.164Z",
    transform: "translate(-103.51 -286.381)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(213.917 355.71)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M137.278,348.392c5.52-6.787,12.843-9.761,15.271-2.409s-4.808,16.695-14.637,15.8S137.278,348.392,137.278,348.392Z",
    transform: "translate(-50.042 -252.258)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M140.589,349.122c-4.564-7.46-11.439-11.381-14.813-4.418s2.555,17.193,12.414,17.6S140.589,349.122,140.589,349.122Z",
    transform: "translate(-124.823 -257.737)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(33.631 129.928)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M153,348.342c-1.7,7.929-3.472,25.862-1.209,30.474-5.441,5.744-19.689,4.8-23.521-.946,1.161-4.291,3.238-24.565.956-29.772S153,348.342,153,348.342Z",
    transform: "translate(-128.272 -345.85)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M128.427,346.475a16.748,16.748,0,0,1,2.409-.2h.01l.127.01c2.945.225,6.095.536,9.2.887,3.5.429,7.109.868,10.1,1.219l.682.117c-.595,3.666-1.112,8.191-1.385,12.521-5.851,3.121-15.174,2.106-20.908-1.034C128.983,354.891,129.022,349.712,128.427,346.475Z",
    transform: "translate(-126.915 -342.179)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M219.714,376.889c-1.385,22.653-4.457,55.7-23.784,76.1-7.8,8.25-19.416,14.354-30.182,13.594-10.269-.721-20.293-9.371-25.423-17.29-20.293-31.3-15.749-72.368-10-90.018S151.989,334.9,170.946,334.1C196.847,333.016,221.655,344.971,219.714,376.889Z",
    transform: "translate(-119.343 -319.362)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M219.4,422.391c2.477-25.355-18.275-26-16.256-56.229-17.114,32-68.6-20.8-74.006,50.787-6.807-26.34-6.407-57.613,11.585-73.158,21.951-18.967,62.021-13.019,72.455,10.619C228.765,362.905,233.475,386.221,219.4,422.391Z",
    transform: "translate(-122.65 -332.527)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M131.695,349.646c-.478,5.266,1.472,9.742,4.349,10.015s5.617-3.793,6.1-9.05-1.473-9.742-4.349-10.005S132.182,344.389,131.695,349.646Z",
    transform: "translate(-65.317 -261.937)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M127.683,349.388c-.478,5.256,1.473,9.742,4.359,10.005s5.617-3.793,6.095-9.05-1.463-9.742-4.349-10.005S128.17,344.122,127.683,349.388Z",
    transform: "translate(-100.43 -264.273)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M127.867,344.8c-.244,2.779,3.325,17.037,16.949,17.593s19.386-11.42,19.7-14.823C164.719,345.308,128.023,343.017,127.867,344.8Z",
    transform: "translate(-98.284 -230.695)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M131.483,340.771a28.373,28.373,0,0,1,12.287,3.637c4.008,2.175,6.758,4.486,8.8,8.455C153.853,341.873,140.152,335.671,131.483,340.771Z",
    transform: "translate(-66.539 -276.213)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M149.283,341.422a28.524,28.524,0,0,0-12.668,2.146c-4.232,1.677-7.206,3.637-9.7,7.333C126.952,339.842,141.3,335.318,149.283,341.422Z",
    transform: "translate(-106.535 -278.619)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M139.281,389.842c-9.771-.712-12.043,12.287-9.761,13.068,4.73,1.619,14.8,1.385,17.378,1.209C150.261,403.885,148.438,390.515,139.281,389.842Z",
    transform: "translate(123.051 524.546)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M133.144,408.846a120.221,120.221,0,0,1,5.178-12.482c3.179-.331,4.681-6.816,5.6-8.143,1.014-1.453,10.1,4.193,10.152,6.651-.848,5.178-13.877,24.009-15.222,25.4S131.389,414.892,133.144,408.846Z",
    transform: "translate(159.164 508.536)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(250.873 673.901)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(36.052)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M132.33,386.044l7.577-.02-.02-8.065c-.01-2.808,1.853-5.188,4.076-5.2l12.394-.029c2.214-.01,4.1,2.36,4.1,5.168l.029,8.065,7.577-.02-.029-8.065c-.02-7.041-5.266-12.746-11.692-12.726l-12.4.029c-6.426.02-11.644,5.754-11.624,12.794Z",
    transform: "translate(-132.31 -365.156)"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "n",
    width: 107.85,
    height: 73.343,
    rx: 0.981,
    transform: "matrix(-1, 0.003, -0.003, -1, 108.051, 90.275)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M138.153,367.139l88.721-.244a9.562,9.562,0,0,1,9.586,9.537l.078,26.057c-36.745,12.053-72.738,12.765-107.854.38l-.068-26.144A9.555,9.555,0,0,1,138.153,367.139Z",
    transform: "translate(-128.586 -349.937)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M.222,0H18.214a.221.221,0,0,1,.221.221V9.464a.221.221,0,0,1-.221.221H.221A.221.221,0,0,1,0,9.464V.222A.222.222,0,0,1,.222,0Z",
    transform: "matrix(-1, 0.003, -0.003, -1, 63.278, 66.717)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M149.819,377.648l-.019-5.363a1.18,1.18,0,0,0-1.19-1.18l-14.121.039a1.186,1.186,0,0,0-1.18,1.19l.01,5.364a1.188,1.188,0,0,0,1.2,1.18l14.111-.039A1.182,1.182,0,0,0,149.819,377.648Z",
    transform: "translate(-87.514 -313.092)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M137.426,365.814c-.029,7.158.029,11-1.492,14.53-2.214,5.139-3.013,7.275-2.721,11.6.292,4.4,3.618,6.007,6.787,6.894,5.178,1.443,11.888-.878,12.473-5.383.712-5.422-1.356-9.167-2.75-13.145-2.311-6.6-2.038-9.04-2.087-14.852C147.6,361.436,137.436,363.1,137.426,365.814Z",
    transform: "translate(162.011 290.377)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(296.399 594.775)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M136.671,429.166c.029-21.5-3.55-49.412-3.384-62.508.068-5.129,4.262-9.615,9.147-9.615h0a9.2,9.2,0,0,1,8.962,9.937c-.771,13.223-4.73,40.87-4.974,63.1C146.413,430.843,136.671,429.937,136.671,429.166Z",
    transform: "translate(-133.282 -357.042)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusinessWoman);
export default __webpack_public_path__ + "static/media/business-woman.1518061cc90e07108b1f98576a34bc66.svg";
export { ForwardRef as ReactComponent };